// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__KamEB","alertIcon":"ConfirmModal_alertIcon__2bdmu"};